import React, { useEffect, useState } from 'react'
import DashKPICards from './DashKPICards'
import { RevenueChart } from '../../Common/RevenueChart'
import DatePicker from 'react-multi-date-picker'
import QuickStatsCard from './QuickStatCard'
import TableViewDashboard from './TableViewDashboard'
import { useDispatch, useSelector } from 'react-redux'
import { cardsCount, chartData, quickStats } from '../../Redux/Actions/DashOptions'
import { toast } from 'react-toastify'
import Loader from '../../Common/Loader'

const MainDashboard = () => {
  const dispatch = useDispatch()
  const currentYear = new Date().getFullYear();

  const [selectedRange, setSelectedRange] = useState([
    new Date(currentYear, 0, 1),
    new Date(currentYear, 11, 31),
  ]);

  const showChartData = useSelector((state) => state?.DashOptionsSlice?.getChartDataDashboard)
  const showCardData = useSelector((state) => state?.DashOptionsSlice?.getCardsCountData)
  const showQuickStatsData = useSelector((state) => state?.DashOptionsSlice?.quickStatsData)
  const loading = useSelector((state) => state?.DashOptionsSlice?.isLoading)


  const handleChangeChart = (range) => {
    if (!range || range.length < 2) return;
    const [start, end] = range;

    const startDate = start?.toDate?.() || start;
    const endDate = end?.toDate?.() || end;

    setSelectedRange([startDate, endDate]);

    const payload = {
      start_month: startDate.toLocaleString('default', { month: 'long' }),
      end_month: endDate.toLocaleString('default', { month: 'long' }),
      year: startDate.getFullYear(),
    };

    dispatch(chartData(payload)).then((res) => {
      if (res?.type !== "dashboard-chart/fulfilled") {
        toast.error('Data not found')
      }
    })
  };

  useEffect(() => {
    dispatch(chartData())
    dispatch(cardsCount())
  }, [])

  useEffect(() => {
    dispatch(quickStats())
  }, [])

  return (
    <div className="bg-gray-50 font-sans min-h-screen">
      {loading && <Loader />}
      <div className='mx-auto px-2'>
        <DashKPICards showCardData={showCardData} />
        <div className="flex flex-col md:flex-row gap-3 mt-3 h-50">
          <div className="w-full md:flex-1 bg-white rounded-xl shadow p-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
              <h2 className="text-xl font-semibold text-gray-800">Revenue Overview</h2>
              <div className='date-picker-dash'>
                <DatePicker
                  value={selectedRange}
                  onChange={(e) => handleChangeChart(e)}
                  range
                  onlyMonthPicker
                  inputClass="custom-input"
                  format="MMMM YYYY"
                  className="border rounded-md px-3 py-1 text-sm shadow-sm"
                />
              </div>
            </div>
            <RevenueChart showChartData={showChartData} />
          </div>
          {/* Quick Stats Card */}
          <div className="w-full md:w-[320px] bg-white rounded-xl shadow">
            <QuickStatsCard data={showQuickStatsData} currentYear={currentYear} showCardData={showCardData} />
          </div>
        </div>
        <TableViewDashboard />
      </div>
    </div>
  )
}

export default MainDashboard
